import styled from 'styled-components';

export const PhotosWrapper = styled.div`
  display: grid;
  gap: 15px;
  height: fit-content;
  grid-template-columns: repeat(
    auto-fill,
    minmax(calc((100% / 3) - 15px), 1fr)
  );

  @media (min-width: ${({ theme }) => theme.smallDesktopBreakpoint}) {
    grid-template-columns: repeat(
      auto-fill,
      minmax(calc((100% / 4) - 15px), 1fr)
    );
  }
`;
